<header class="modal-header bg-white border-bottom-0">
  <h5 class="modal-title" id="modal-basic-title font-weight-bold">
    Categorias
  </h5>
  <button type="button" class="close" (click)="confirm()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body">
  <ul>
    <li *ngFor="let ok of listaCategoriasRnt">
      {{ok.descripcion}}
    </li>
  </ul>
</section>
